/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nudge_Enable_Notetaker_ActionInputs */



/**
* | output |
* | --- |
* | "Turn the notetaker on" |
*
* @param {Nudge_Enable_Notetaker_ActionInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const nudge_enable_notetaker_action = /** @type {((inputs?: Nudge_Enable_Notetaker_ActionInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nudge_Enable_Notetaker_ActionInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Notetaker aanzetten")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activer le notetaker")
	return /** @type {LocalizedString} */ ("Turn the notetaker on")
});